import { isResource } from '@medplum/core'
import type {
  CodeableConcept,
  Communication,
  Reference,
} from '@medplum/fhirtypes'
import { hasCodeableConcept } from '#src/codeableConcept.ts'
import { COMMUNICATION_CATEGORIES } from '#src/models/communications/constants.ts'
import { ExtendedCommunication } from '#src/models/communications/ExtendedCommunication.ts'
import type { QueryTypes } from '#src/search.ts'
import { isOfType } from '#src/utils.ts'

export class SDRNotificationCommunication extends ExtendedCommunication {
  static isInstance(value: unknown): value is Communication {
    return (
      isResource(value) &&
      isOfType(value, 'Communication') &&
      hasCodeableConcept(
        value.category,
        COMMUNICATION_CATEGORIES.sdrNotification
      )
    )
  }

  static searchQuery(partOf: Reference): QueryTypes {
    return {
      ...ExtendedCommunication.baseSearchQuery(),
      category: COMMUNICATION_CATEGORIES.sdrNotification,
      'part-of': partOf,
    }
  }

  constructor(
    data: Omit<
      Communication,
      'resourceType' | 'payload' | 'status' | 'category'
    > & {
      status?: Communication['status']
      category?: CodeableConcept
      message?: string
    }
  ) {
    super({
      ...data,
      category: COMMUNICATION_CATEGORIES.sdrNotification,
    })
  }
}
